module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/female-3-51f4d4506b47feec8b445dfd86155776.jpg";